import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=3948f782&"
import script from "./user.js?vue&type=script&lang=js&"
export * from "./user.js?vue&type=script&lang=js&"
import style0 from "./index3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3948f782')) {
      api.createRecord('3948f782', component.options)
    } else {
      api.reload('3948f782', component.options)
    }
    module.hot.accept("./index3.vue?vue&type=template&id=3948f782&", function () {
      api.rerender('3948f782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/User2/index3.vue"
export default component.exports